<template>
  <div class="card shade" :class="{ 'mx-auto': last }" @mouseover="toggleCardDarken" @mouseout="toggleCardDarken">
    <router-link to="/event/add"><span></span></router-link>
    <div class="card-img-overlay d-flex flex-column">
      <div class="ultra-light-weight text-center mt-auto">
        <h1 class="display-4">Add an Event</h1>
      </div>
      <div class="mb-auto text-center mt-3">
        <img class="mx-auto add-event-img" src="../assets/images/plus-circle-outline.png">
      </div>
    </div>
  </div>
</template>

<script>
import CardMixin from '../mixins/card'

export default {
  mixins: [CardMixin],
  props: {
    last: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
@import "../assets/styles/card.css";
</style>

<style scoped>
.add-event-img {
  max-width: 110px;
  filter: invert(0.6)
}
</style>
